import Migration from './Migration';
import Promotion from './Promotion';

export default { Migration, Promotion };
